const scripts = [
    'js/jquery.js',
    'plugins/revolution/js/jquery.themepunch.revolution.min.js',
    'plugins/revolution/js/jquery.themepunch.tools.min.js',
    'plugins/revolution/js/extensions/revolution.extension.actions.min.js',
    'plugins/revolution/js/extensions/revolution.extension.carousel.min.js',
    'plugins/revolution/js/extensions/revolution.extension.kenburn.min.js',
    'plugins/revolution/js/extensions/revolution.extension.layeranimation.min.js',
    'plugins/revolution/js/extensions/revolution.extension.migration.min.js',
    'plugins/revolution/js/extensions/revolution.extension.navigation.min.js',
    'plugins/revolution/js/extensions/revolution.extension.parallax.min.js',
    'plugins/revolution/js/extensions/revolution.extension.slideanims.min.js',
    'plugins/revolution/js/extensions/revolution.extension.video.min.js',
    'js/main-slider-script.js',
    'js/bootstrap.min.js',
    'js/jquery.fancybox.js',
    'js/jquery-ui.js',
    'js/owl.js',
    'js/mixitup.js',
    'js/isotope.js',
    'js/appear.js',
    'js/jquery.mCustomScrollbar.concat.min.js',
    'js/wow.js',
    'js/element-in-view.js',
    'js/script.js',
    'js/shim.js',
];

export default scripts;